module.exports = __webpack_public_path__ + "media/images/icons/icn_032-7600adf82808e7ba399f81a1df9fc67d.svg";